export const CustomEvents = {
  LOADER_EVENTS: {
    show: 'loader:show',
    hide: 'loader:hide',
    showLocal: 'loader:showlocal',
    hideLocal: 'loader:hidelocal',
    visible: 'loader:visible',
    hidden: 'loader:hidden'
  },
  KEYBOARD_EVENTS: {
    escape: 'ku:key:escape',
    enter: 'ku:key:enter',
    tab: 'ku:key:tab',
  },
  BURGER_EVENTS: {
    click: 'burger:clicked',
    close: 'burger:close'
  },
  MQ_EVENTS: {
    xs: {
      in: 'mq.xs.in',
      out: 'mq.xs.out',
      current: 'mq.xs.cur'
    },
    sm: {
      in: 'mq.sm.in',
      out: 'mq.sm.out',
      current: 'mq.sm.cur'
    },
    md: {
      in: 'mq.md.in',
      out: 'mq.md.out',
      current: 'mq.md.cur'
    },
    lg: {
      in: 'mq.lg.in',
      out: 'mq.lg.out',
      current: 'mq.lg.cur'
    },
    xl: {
      in: 'mq.xl.in',
      out: 'mq.xl.out',
      current: 'mq.xl.cur'
    }
  },
  SEARCH_EVENTS: {
    visible: 'search:visible',
    hidden: 'search:hidden',
    toggle: 'search:toggle',
    trigger: 'click.search'
  },
  BACKDROP_EVENTS: {
    show: 'backdrop:show',
    hide: 'backdrop:hide',
    hidden: 'backdrop:hidden',
    shown: 'backdrop:shown'
  },
  PRODUCT_EVENTS: {
    addtocart: 'product:addtocart',
    addedtocart: 'product:addedtocart',
    sizerequired: 'product:sizerequired',
    sizechanged: 'product:sizechanged',
    notifyme: 'product:notifyme',
    notifymeuniquesize: 'product:notifymeuniquesize',
    addtowish: 'product:addtowish',
    addedtowish: 'product:addetowish',
    removefromwish: 'product:removefromwish',
    removedfromwish: 'product:removedfromwish',
    disableButton: 'product:disablebutton',
    disableProductButton: 'product:disableProductButton',
    productitemopen: 'product:open',
    productitemclose: 'product:close'
  },
  SIZES_EVENTS: {
    sizesopen: 'sizes:open',
    sizesclose: 'sizes:close'
  },
  CARTBAR_EVENTS: {
    cartbaropened: 'cartbar:open',
    cartbarclosed: 'cartbar:close'
  },
  DROPDOWN_EVENTS: {
    open: 'dropdown:open',
    close: 'dropdown:close',
    opened: 'dropdown:opened',
    closed: 'dropdown:closed'
  },
  MODAL_EVENTS: {
   afterClose: 'modal:afterClose',
   afterOpen: 'modal:afterOpen',
   afterUpdateContent: 'modal:afterUpdateContent',
   egonValidation: 'modal:egonValidation',
   hidden: 'modal:hidden',
   hide: 'modal:hide',
   show: 'modal:show',
   shown: 'modal:shown',
  },
  SORT_BY_EVENTS: {
    changed: 'sortBy:changed'
  },
  FILTERS_EVENTS: {
    updated: 'query:updated',
    pageLoaded: 'ajaxPage:loaded'
  },
  PAGE_LAYOUT_EVENTS: {
    changed: 'pageLayout:changed',
    initDatepicker: 'pageLayout:initDatepicker'
  },
  INFINITE_SCROLL_EVENTS: {
    next: 'infiniteScroll:next'
  },
  FULL_MEDIA_EVENTS: {
    scrolled: 'fullMedia:scrolled'
  },
  HEADER_EVENTS: {
    expanded: 'header:expanded',
    collapsed: 'header:collapsed'
  },
  QUICK_CATEGORIES_EVENTS: {
    show: 'quickCategories:show',
    visible: 'quickCategories:visible'
  },
  COOKIE: {
    accepted: 'cookie:accepted'
  },
  RETURN_EVENTS: {
    subsituteProduct: 'product:substituted'
  },
  TOOLTIP_EVENTS: {
    create: 'tooltip:create',
    destroy: 'tooltip:destroy'
  },
  MENU_EVENTS: {
    showBackdrop: 'menu:showBackdrop'
  },
  SHIPMENT_EVENTS: {
    valid: 'checkout:proceed',
    invalid: 'checkout:stop'
  },
  ZOOM_EVENTS: {
    open: 'zoom:open',
    close: 'zoom:close'
  },
  BOOK_LAYER_EVENTS: {
    open: 'bookLayer:open',
    close: 'bookLayer:close'
  },
  CODE_VERIFICATION_EVENTS: {
    newCodeCreated: 'codeVerification:codeGenerated',
  },
  TIMER_EVENTS: {
    timerExpired: 'timer:expired',
  },
  TRACKING: {
    loadMore: 'track:loadMore',
  },
  PAGINATION_EVENTS: {
    pageUpdated: 'page:updated'
  },
  MINICART_EVENTS: {
    update: 'minicart:update',
    enter: 'minicart:enter',
    exit: 'minicart:exit',
  },
  WISHLIST_EVENTS: {
    update: 'wishlist:update',
    enter: 'wishlist:enter',
    exit: 'wishlist:exit',
  },
  TRIGGERED_LABEL_EVENTS: {
    set: 'triggeredlabel:set',
    trigger: 'triggeredlabel:trigger'
  },
  PAYMENTS_EVENTS: {
    standardPaymentMethodSelected: 'payments:standardPaymentMethodSelected',
    adyenPaymentMethodSelected: 'payments:adyenPaymentMethodSelected',
    adyenButtonSubmit: "payments:adyenbuttonSubmit"
  },
  VIDEO_EVENTS: {
    loadedData: 'video:loadedData'
  },
  FORM_EVENTS: {
    formSubmitted: 'form:submitted',
    formReplaced: 'form:replaced'
  },
  YEXT_EVENTS: {
    faqsLoaded: 'faqs:loaded'
  }
};

export const EditModeEvents = {
  LOOKBOOK_EVENTS: {
    markerAdded: 'lookbook:marker:added',
    markerRemoved: 'lookbook:marker:removed',
  }
};
